import Vue from "vue";
import quit from "@/views/homePage/quit.vue"
import BottomNavigation from "@/views/homePage/BottomNavigation.vue"
import felixItem from "./felixItem.vue"


//注册全局组件
Vue.component("quitVue",quit)
Vue.component(BottomNavigation.name,BottomNavigation)
Vue.component(felixItem.name,felixItem)


function phone (str) {
  let rgs =/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/ 
  return rgs.test(str)
}
Vue.directive('phone', {
  inserted(el) {
    el.addEventListener('input', (event) => {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
    });
  }
});


/**
 * 将时间戳转换为格式化的日期字符串
 * @param {number} timestamp - 以秒为单位的时间戳
 * @returns {string} - 格式化后的日期字符串，格式为 "年-月-日"
 */
function timeCt(timestamp) {
  const date = new Date(timestamp* 1000);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，所以+1
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}年${month}月${day}日`;
}
Vue.prototype.$timeCt = timeCt;
Vue.prototype.$phone = phone